import React, { useContext } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import styles from "./SideBarSubMenu.module.css";
import { Link, useLocation } from "react-router-dom";
import RouterContext from "../../Router/routerContext";

const AccordiaonMenus = (tabs, handleActiveSubMenu, route,fileteredRotues) => {
  // console.log("Tabs", tabs);
  console.log("routes", route);
  const handleClick = (submenu) => {
    handleActiveSubMenu(submenu);
  };
  return tabs.map((tab) => {
    const checkAccordion = tab?.menu?.some((submenuItem) =>
      fileteredRotues.some((r) => r.path === submenuItem?.link)
    );
    if (checkAccordion) {
      return (
        <AccordionTab
          key={tab.accordion}
          header={
            <>
              <p className={styles.acHeader}>{tab.accordion}</p>
            </>
          }
          disabled={tab.disabled}
        >
          {tab.menu &&
            tab.menu.map(({ id, Icon, label, isActive, link }, i) =>
              fileteredRotues.some((r) => r.path === link) ? (
                <div
                  onClick={() =>
                    handleClick({
                      accordion: tab.accordion,
                      isActive: true,
                      menu: { id, Icon, label, isActive: route === link, link },
                    })
                  }
                  key={i}
                  className={styles.acLink}
                >
                  {route === link ? (
                    <span className={styles.active}></span>
                  ) : (
                    ""
                  )}
                  <Icon
                    style={{
                      fontSize: "1.3rem",
                      verticalAlign: "bottom",
                      color:route===link?'var(--color--1)': "#48494b",
                    }}
                  />{" "}
                  <Link to={link} className={styles.subMenu}>
                    {label}
                  </Link>
                </div>
              ) : (
                ""
              )
            )}
        </AccordionTab>
      );
    }
  });
};
const subMenuTab = (menu, handleActiveSubMenu, route,fileteredRotues) => {
  const handleClick = (submenu) => {
    handleActiveSubMenu(submenu);
  };
  return menu.map(({ id, Icon, label, isActive, link }, i) =>
    fileteredRotues?.some((r) => r.path === link) ? (
      <div
        onClick={() =>
          handleClick({ id, Icon, label, isActive: route === link, link })
        }
        key={i}
        className={styles.acLink}
      >
        {route === link ? <span className={styles.active}></span> : ""}
        <Icon
          style={{
            fontSize: "1.3rem",
            verticalAlign: "bottom",
            color: "#48494b",
          }}
        />{" "}
        <Link to={link} className={styles.subMenu}>
          {label}
        </Link>
      </div>
    ) : null
  );
};

function SideBarSubMenu({ handleActiveSubMenu, subMenus, }) {
  const {fileteredRotues} =useContext(RouterContext)
  const location = useLocation();
  const route =
    location.pathname.split("/app/")[1] === undefined
      ? ""
      : location.pathname.split("/app/")[1];
  const isNotAccordion = subMenus.some((m) => m.accordion === false);

  return (
    <div className={styles.subMenuWrapper}>
      {isNotAccordion ? (
        subMenuTab(subMenus[0].menu, handleActiveSubMenu, route,fileteredRotues)
      ) : (
        <Accordion activeIndex={0}>
          {AccordiaonMenus(subMenus, handleActiveSubMenu, route,fileteredRotues)}
        </Accordion>
      )}
    </div>
  );
}

export default SideBarSubMenu;
